import styled from "styled-components/macro";
import {
    AvatarImg,
    DropContainer,
    FormAvatar,
    HeaderLang,
    HeaderLeft,
    HeaderLogo,
    HeaderRight,
} from "../../components/ui/Content";
import React, {useEffect, useRef, useState} from "react";
import {
    DropDown,
    DropUp,
    Exit,
    FemaleAvatar,
    Globe,
    HeaderCross,
    HeaderMenu,
    LogoBlack,
    MaleAvatar,
} from "../../icon/Icon";
import {HeaderDropDownContent, HeaderDropDownModal, LangDropDownContent} from "../../components/ui/Modal";
import {Body1Pointer, Body2} from "../../components/Font";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {Logout} from "../Auth/slice";
import {WindowSizePXEnum} from "../../interface/Basic/window";
import {LanguageEnum} from "../../enum/language";
import {useOnClickOutside} from "../../hooks/useClickOutside";
import {useTranslation} from "react-i18next";
import {LocalStorageEnum} from "../../enum/localStorage";

let initDropDown: HTMLDivElement;
let initLang: HTMLDivElement;

export interface HeaderProps {
    mobileMenuOpen: boolean
    setMobileMenuOpen: () => void
}

export const Header = ({setMobileMenuOpen, mobileMenuOpen}: HeaderProps) => {
    const {i18n} = useTranslation();
    const {avatar, personalInfo} = useAppSelector(state => state.account)
    const [avatarOpened, setAvatarOpened] = useState(false)
    const [langOpened, setLangOpened] = useState(false)
    const dispatch = useAppDispatch()
    const lang = localStorage.getItem(LocalStorageEnum.lang)
    const dropDownRef = useRef(initDropDown)
    const langRef = useRef(initLang)
    useOnClickOutside(dropDownRef, () => setAvatarOpened(false));

    useEffect(() => {
        const onClick = (e: MouseEvent) => {
            if (langOpened) {
                langRef.current?.contains(e.target as Node) || setLangOpened(false);
            }
        }
        document.addEventListener('click', onClick);
        return () => document.removeEventListener('click', onClick);
    }, [langOpened]);

    return <>
        <HeaderContainer>
            <HeaderContent>
                <HeaderLeft>
                    <HeaderMenuContainer onClick={() => setMobileMenuOpen()}>
                        {!mobileMenuOpen && <HeaderMenu/> || <HeaderCross/>}
                    </HeaderMenuContainer>
                    <HeaderLogo>
                        <LogoBlack className={'logo'}/>
                    </HeaderLogo>
                </HeaderLeft>
                <HeaderRight>
                    <div style={{position: 'relative'}}>
                        <HeaderButton
                            ref={dropDownRef}
                            onClick={() => {
                                setAvatarOpened(prev => !prev)
                            }}>
                            {avatarOpened &&
                            <HeaderDropDownContent>
                                <HeaderDropDownModal onClick={() => {
                                    dispatch(Logout())
                                }}>
                                    <Exit/>
                                    <Body1Pointer>
                                        Выйти
                                    </Body1Pointer>
                                </HeaderDropDownModal>
                            </HeaderDropDownContent>}


                            {avatar &&
                            <FormAvatar size={40}>
                                <AvatarImg src={`${process.env.REACT_APP_API}${avatar.path}`}/>
                            </FormAvatar> ||
                            <FormAvatar size={40}>
                                {(!personalInfo.sex || personalInfo.sex?.name === "Мужской") && <MaleAvatar/> ||
                                <FemaleAvatar/>}
                            </FormAvatar>}
                            <DropContainer>
                                {avatarOpened ? <DropUp/> : <DropDown/>}
                            </DropContainer>
                        </HeaderButton>
                    </div>

<div style={{position: 'relative'}}>
    <HeaderLang
        ref={langRef}
        onClick={() => {
            setLangOpened(!langOpened)
        }}>
        <Globe/>
        <Body2>{lang === LanguageEnum.Ru ? `RUS` : 'ENG'}</Body2>
    </HeaderLang>
    {langOpened &&
    <LangDropDownContent>
        <Body2
            className={`${lang === LanguageEnum.Ru ? 'tertiary' : 'secondary'} pointer`}
            onClick={() => {
                localStorage.setItem(LocalStorageEnum.lang, LanguageEnum.Ru)
                i18n.changeLanguage('ru-RU')
                setLangOpened(false)
            }}>Русский</Body2>
        <Body2
            className={`${lang === LanguageEnum.En ? 'tertiary' : 'secondary'} pointer`}
            onClick={() => {
                localStorage.setItem(LocalStorageEnum.lang, LanguageEnum.En)
                i18n.changeLanguage('en-US')
                setLangOpened(false)
            }}>English</Body2>
    </LangDropDownContent>}
</div>


                </HeaderRight>
            </HeaderContent>
        </HeaderContainer>
    </>
}

const HeaderContainer = styled.div`
  z-index: 100;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 56px;
  align-items: center;
  justify-content: center;
  background: ${({theme}) => theme.color.primaryBackground};
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
`

const HeaderContent = styled.div`
  display: flex;
  width: 1100px;
  justify-content: space-between;
  align-items: center;
  @media (max-width: ${WindowSizePXEnum.md}) {
    justify-content: space-between;
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    justify-content: space-between;
    width: 701px;
    margin: 0 16px;
  }
`
const HeaderButton = styled.div`
  display: flex;
  gap: 5px;
  cursor: pointer;
  align-items: center;
`

const HeaderMenuContainer = styled.div`
  svg {
    display: none;
    @media (max-width: ${WindowSizePXEnum.md}) {
      display: unset;
    }
  }
`

